import { withTheme } from "@emotion/react";
import CITFormGroup from "../../../../Form/CITFormGroup"
import { Typography, Box, Stack } from "@mui/material";
import * as React from 'react';
import FileInput from "../../../../Form/FileInput";
import DateInput from "../../../../Form/DateInput";



const Acknowledgement = (props) => {

    const theme = props.theme

    return (

        <Box width={'inherit'}>
            <Stack mx={{ xs: '19px', sm: '60px', md: '85px' }} justifyContent={'space-around'} mt={'24px'} >
                <Typography width={{ sm: '668px', md: '998px' }} mb={'24px'} mt={'48px'} sx={{ ...theme.typography.heading, fontSize: { xs: '18px', sm: '20px', md: '29px' } }} gutterBottom>
                    {'ACKNOWLEDGEMENT'}
                </Typography>
                <Typography mb={'24px'} sx={theme.typography.body} gutterBottom>
                        Please read carefully and sign,
                </Typography>
                <Typography mb={'24px'} sx={theme.typography.body} gutterBottom>
                        In signing this application, I certify that I have read and fully understand the questions asked in this application and 
                        that all answers given by me are true, accurate, and complete. I also understand that the omission, concealment, or
                        misrepresentation of any fact on this application or during any interview for employment may jeopardize my 
                        chances for employment and be the cause for my immediate dismissal from employment.
                </Typography>
                <Typography mb={'24px'} sx={theme.typography.body} gutterBottom>
                        I give Care In Touch Home Health Agency permission to use any information in this application to enable it and its 
                        agents to verify the information contained in this application. I also authorize present and former employees, 
                        educational institutions I have attended, credit agencies, all references, and any other persons to answer all 
                        questions asked by Care In Touch Home Health Agency with regard to any of the subjects covered by this 
                        application. I also understand that in connection with my application for employment or my employment, Care In 
                        Touch Home Health Agency may conduct a criminal background investigation and that my employment may be 
                        contingent on the results of such investigation. I release Care In Touch Home Health Agency, its agents, and all 
                        affiliated entities, as well as any person or situation that provides any information about me, from any and all
                        liability whatsoever resulting from any such investigation or the disclosure of such information.
                </Typography>
                <Typography mb={'24px'} sx={theme.typography.body} gutterBottom>
                        In consideration of my employment and of my being considered for employment by Care In Touch Home Health 
                        Agency,I agree to abide by all rules and regulations, which I understand are subject to change at any time for any 
                        reason without prior notice. I also understand that if employed, I will be an employee at will and employed for no 
                        definite period of time. I understand that either Care In Touch Home Health Agency or I can terminate my 
                        employment at any time, with orwithout cause and with or without advance notice. I further understand that no 
                        communication, whether oral or written,by any representative of Care In Touch Home Health Agency, at any time, 
                        can constitute a contract of employment. No representative or agent of Care In Touch Home Health Agency has the
                        authority to enter into any agreement for employment for any specific period of time or to make any agreement 
                        contrary to the foregoing.

                </Typography>
                <Typography mb={'24px'} sx={theme.typography.body} gutterBottom>
                        I am willing to submit to a physical examination, including the analysis for the detection of the use of unlawful drugs
                        or substances in accordance with the applicable laws. If I receive an offer of employment, I agree that my continued
                        employment may be contingent on the results
                </Typography>
                <Typography mb={'24px'} sx={theme.typography.body} gutterBottom>
                        I HAVE READ THE ABOVE AND FULLY UNDERSTAND IT.
                </Typography>
                <CITFormGroup mt={'0px'} mx={'0px'} width={'100%'}>
                        <FileInput showImage title="Add File" fileLable={'Your signature'} />
                        <DateInput dateLable={'Date'} />
                </CITFormGroup>

            </Stack>
        </Box>



    )
}

export default withTheme(Acknowledgement);